// extracted by mini-css-extract-plugin
module.exports = {"Table":"Headers_Table__lN-Yt"};